module.exports = __webpack_public_path__ + "res/img_bottom.15454c7ff6b015e915aff65c6d956f27.png";